/** AI and API base URL helpers */

const PRODUCTION_AI_URL = 'https://teach-ai-aq9x.vercel.app';
const DEVELOPMENT_AI_URL = 'http://localhost:5001';

export function getAiBackendUrl(): string {
  if (process.env.REACT_APP_AI_URL) {
    return process.env.REACT_APP_AI_URL;
  }
  return process.env.NODE_ENV === 'development' ? DEVELOPMENT_AI_URL : PRODUCTION_AI_URL;
}
